export const state = (): object => ({});
